module.exports = __webpack_public_path__ + "img/et_tech.fa70eb59.png";